"use client";

import React from "react";
import { useRouter } from "next/navigation";
import { Chip } from "../ui/Chip";
import { FiTrendingUp } from "react-icons/fi"; // Importing a trending up icon from react-icons

interface ChipsFormIconProps {
    tagNames?: string[];
    onTagClick?: (tagName: string) => void;
}

const defaultChips = [
    "நரேந்திர மோடி",
    "தேர்தல்கள்",
    "ஐபிஎல் 2023",
    "சமீபத்திய செய்திகள்",
    "முக்கிய செய்திகள்",
    "அரசியல்",
];

export default function ChipsFormIcon({ tagNames, onTagClick }: ChipsFormIconProps) {
    const router = useRouter();
    const chips = tagNames && tagNames.length > 0 ? tagNames : defaultChips;
    const highlightedChip = chips[0];

    return (
        <div className="flex flex-wrap gap-3 p-2">
            {chips.map((chipName) => (
                <div key={chipName} className="flex items-center">
                    <Chip
                        onClick={() => {
                            if (onTagClick) {
                                onTagClick(chipName);
                            } else {
                                router.push(`/search/${encodeURIComponent(chipName)}`);
                            }
                        }}
                        label={
                            <div className="flex items-center gap-2">
                                {chipName}
                                <FiTrendingUp className="text-sm text-red-500" />
                            </div>
                        }
                        active={chipName === highlightedChip}
                        className="bg-012061 text-12-tamil-400 hover:bg-[#E3E4E8]"
                    />
                </div>
            ))}
        </div>
    );
}
